import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import MainLoading from '../../utils/MainLoading';

const InfoModal = (props) => {
    const [cmpData, setCmpData] = useState([])
    const data = useSelector(state => state.saloon_detail)

    useEffect(() => {
        setCmpData(data.saloon_detail.users.filter(item => item.id === props.id)[0])
    }, [props.id])

  return (
        <div>
            {props.show && (
                <Modal show={props.show} className="expo_modal">
                    {/* {userprofile.loading ?
                        <MainLoading  />
                    : */}
                        <>
                            <Modal.Header>
                                <Modal.Title>{cmpData.title}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div><span>برنــد:</span><span>{cmpData.brand ? cmpData.brand : '-'}</span></div>
                                <div><span>مدیرعامــل:</span><span>{cmpData.manager_name ? cmpData.manager_name : '-'}</span></div>
                                <div><span>شماره مدیرعامــل:</span><span>{cmpData.manager_number ? cmpData.manager_number : '-'}</span></div>
                                <div><span>ایمیــل:</span><span>{cmpData.email ? cmpData.email : '-'}</span></div>
                                <div><span>آدرس:</span><span>{cmpData.address ? cmpData.address : '-' }</span></div>

                                <div><span>دربــاره غرفه:</span><span>{cmpData.description ? cmpData.description : '-' }</span></div>
                                <div><span>تعداد بازدید:</span><span>{cmpData.view_count ? cmpData.view_count : '-' }</span></div>

                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={props.close} className='px-3 btn-sm'>
                                    بستن
                                </Button>
                            </Modal.Footer>
                        </>
                    {/* } */}
                </Modal>
            )}
        </div>
    )
};

export default InfoModal;
